import styles from "./footer.module.css";
import googleplay from "../../assets/Google_Play_login.png"
import AakashLogo from '../../assets/aakash-logo.png'
import facebook from '../../assets/facebook_icon.svg'
import twitter from '../../assets/twitter_icon.svg'
import linkedin from '../../assets/linkedin_icon.svg'
import instagram from '../../assets/instagram_icon.svg'
import { getExamConfig, getExamType } from "utils/common";

const Footer = () => {
  let telephone = "1800-103-2727"
  let email = "acstsupport@aesl.in"

  const exam_type = getExamType()
  const examConfig = getExamConfig(exam_type)

  if (examConfig?.commonSettings) {
    if (exam_type == "iACST") {
      telephone += `, ${examConfig?.commonSettings?.supportNumber}`
    } else {
      telephone = examConfig?.commonSettings?.supportNumber
    }

    email = examConfig?.commonSettings?.supportEmail
  }

  return (
    <div className={styles.footer}>
      <div style={{ width: "90%" }}>
        <div className={styles.footerContent}>
          <div className={styles.aakashfooter}>
            <span><img src={AakashLogo} /></span>
            <ul style={{ display: "block" }}>
              <li>
                <h6>Registered office Address:</h6>
              </li>
              <li style={{ marginLeft: '0px', marginTop: '0px' }}>
                <p style={{ marginLeft: '0px', marginTop: '0px' }}>Aakash Educational Services Limited, 3rd Floor,<br />Incuspaze Campus - 2, Plot No. 13, Sector - 18,<br /> Udyog Vihar, Gurugram, Haryana - 122015</p>
              </li>
              <li>
                <h6>Telephone:</h6><p>{telephone}</p>
              </li>
              <li>
                <h6>Email:</h6>
                <p>{email}</p>
              </li>
            </ul>
          </div>
          <div className={styles.socialicons}>
            <span>Follow Us On</span>
            <ul>
              <li>
                <a
                  href="https://www.facebook.com/aakasheducation"
                  target="_blank"
                >
                  <img
                    alt
                    src={facebook}
                  />
                </a>
              </li>
              <li>
                <a href="https://twitter.com/AESL_Official" target="_blank">
                  <img src={twitter} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/aakasheducation/"
                  target="_blank"
                >
                  <img src={instagram} />
                </a>
              </li>
              <li>
                <a
                  href="https://in.linkedin.com/company/aakash-educational-services-limited"
                  target="_blank"
                >
                  <img src={linkedin} />
                </a>
              </li>
            </ul>
          </div>
          <div>
            <span>Download Aakash JEE NEET app</span>
            <ul>
              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.aakash.jee.neet.app&hl=en_IN&pli=1"
                  target="_blank"
                >
                  <img src={googleplay} />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div style={{ height: "1px", backgroundColor: "#E2E6E9" }}></div>
        <div
          style={{
            padding: "47px 0px 47px 0px",
            textAlign: "center",
            color: "#5B636B",
          }}
        >
          Copyright {new Date().getFullYear()} |{" "}
          <a
            target="_blank"
            href="https://www.aakash.ac.in/"
            style={{ color: "#5B636B" }}
          >
            www.aakash.ac.in
          </a>{" "}
          | Disclaimer
        </div>
      </div>
    </div>
  );
};
export default Footer;
